import { AxiosInstance, AxiosResponse } from "axios";
import { fetcher } from "../../configurations";
import {
    UpsMasterShipmentDetail,
    UpsMasterShipmentListResponse,
} from "../../interfaces";

export class UpsMasterShipmentRepository {
    private lmBootApi: AxiosInstance;

    constructor() {
        this.lmBootApi = fetcher(process.env.REACT_APP_URL_API_2 as string);
    }

    listMasterShipments(params: {
        status?: string;
        limit?: number;
        offset?: number;
    }): Promise<AxiosResponse<UpsMasterShipmentListResponse>> {
        return this.lmBootApi.get<UpsMasterShipmentListResponse>("/ups/master-shipments", {
            params,
        });
    }

    getMasterShipmentDetail(gccn: string): Promise<AxiosResponse<UpsMasterShipmentDetail>> {
        return this.lmBootApi.get<UpsMasterShipmentDetail>(`/ups/master-shipments/${encodeURIComponent(gccn)}`);
    }

    closeMasterShipment(gccn: string): Promise<AxiosResponse<UpsMasterShipmentDetail>> {
        return this.lmBootApi.post<UpsMasterShipmentDetail>(
            `/ups/master-shipments/${encodeURIComponent(gccn)}/close`
        );
    }

    deleteChildOrder(gccn: string, orderId: string): Promise<AxiosResponse<UpsMasterShipmentDetail>> {
        return this.lmBootApi.delete<UpsMasterShipmentDetail>(
            `/ups/master-shipments/${encodeURIComponent(gccn)}/orders/${encodeURIComponent(orderId)}`
        );
    }
}
